module.exports = __webpack_public_path__ + "static/media/large_tablet_frame_sm.434eb612.png";